import React from 'react'
import EditContainer from '../../../../component/users/organization-admin/edit-user-list/EditContainer'
 
function EditUserList() {
  return (
    <div className='page-body'>
    <EditContainer/>
 </div>
  )
}

export default EditUserList
